import { render, staticRenderFns } from "./BriefFeedbackPanel.vue?vue&type=template&id=56f83cdc&scoped=true"
import script from "./BriefFeedbackPanel.vue?vue&type=script&lang=js"
export * from "./BriefFeedbackPanel.vue?vue&type=script&lang=js"
import style0 from "./BriefFeedbackPanel.vue?vue&type=style&index=0&id=56f83cdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f83cdc",
  null
  
)

export default component.exports